// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__X8kTr","image":"App_image__1tEFY"};